<template>
    <HomeLayout :isShowDelivery="false" class="overflow-x-hidden">
        <div class="text-a-brown-502314 text-18 font-bold text-center py-4">Rewards</div>
        <UserPointInfo></UserPointInfo>
        <CategoryList
                v-if="categoryConfig != null"
                class="mt-8"
                ref="cate-list"
                :categoryConfig="categoryConfig"
        ></CategoryList>
    </HomeLayout>
</template>
<script>
import Util from '@/helper/Utility.js';
import HomeLayout from '@/components/Layout/Page/HomeLayout.vue'
import UserPointInfo from '../component/UserPointInfo/UserPointInfo.vue';
import CategoryList from '../component/CategoryList/CategoryList.vue';
import ConfigManager from '@/config/ConfigManager';
import { CategoryConfigBuilder } from '@/core/Campaign/config/CategoryConfigModel';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';

export default {
    mixins: [AuthStatusMixin],
    components: {
        HomeLayout,
        UserPointInfo,
        CategoryList,
    },
    data: function() {
        return {
            categoryConfig: null,
        };
    },
    created: function() {
        this.tracking.screenName('rewards');
        this.tracking.event('rewards','view_rewards', null, null);
        this.setScrollLoadMore();

    },
    mounted: function () {
        Util.scrollTop();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        onAccountInit: function () {
            this.initialCategory();
        },

        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        initialCategory: function () {
            var configStr = ConfigManager.getCategoryMenuReward();
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(configStr)
                .setLocale(this.localeCode)
                .create();

            this.categoryConfig = categoryConfig;
        },

        loadMore: function() {
            this.$refs['cate-list'].loadMore();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
